import { render, staticRenderFns } from "./Espectro.vue?vue&type=template&id=55877fa6&"
import script from "./Espectro.vue?vue&type=script&lang=js&"
export * from "./Espectro.vue?vue&type=script&lang=js&"
import style0 from "./Espectro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports